import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
// Genel
import Anasayfa from './pages/anasayfa';
import Login from './Login';

// User
import UserDashboard from './pages/user/userDashboard';
import UseManageLicense from './pages/user/manageLicense';

// Admin
import AdminDashboard from './pages/admin/adminDashboard';
import AdminPaket from './pages/admin/paket';
import AdminLisans from './pages/admin/lisans';
import AdminCihaz from './pages/admin/cihaz';
import AdminSMTPAyar from './pages/admin/smtpayar';
import AdminUsers from './pages/admin/users';

// Yazılımlar
import App_IsletmeRadar from './pages/softwares/isletmeradar';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <HelmetProvider>
      <Router>
        <Routes>
          {/* Genel */}
          <Route path="/" element={<Anasayfa />} />
          <Route path="/login" element={<Login />} />

          {/* User */}
          <Route path="/dashboard" element={<UserDashboard />} />
          <Route path="/managelicense" element={<UseManageLicense />} />

          {/* Admin */}
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/paket" element={<AdminPaket />} />
          <Route path="/admin/lisans" element={<AdminLisans />} />
          <Route path="/admin/cihaz" element={<AdminCihaz />} />
          <Route path="/admin/apiayar" element={<AdminSMTPAyar />} />
          <Route path="/admin/users" element={<AdminUsers />} />

          {/* Yazılımlar */}
          <Route path="/app/isletmeradar" element={<App_IsletmeRadar />} />
        </Routes>
      </Router>
    </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
